export default "__VITE_ASSET__e408b36c__"